import { createSelector } from 'reselect';
import DomainName from './name';

export const featureSelector = state => state[DomainName];

export const notifications = createSelector(
  featureSelector,
  state => state['notifications']
);
